const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/components/CIS4mStyled.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useConnectToChildCIS4mComponents } from '../hooks';
import { css, cx } from '@emotion/css';
import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material';

interface Props {
    children: any;
    className?: string;
}

export const getCIS4mStyledCSS = (theme: Theme) => css`
    & > .MobileFormSection,
    & > .MobileFormBlock > .MobileFormSection {
        display: block;
        padding: ${theme.spacing(2)};
        background-color: ${theme.palette.common.white};

        & > .MobileFormSectionHeader {
            padding: 0;
            margin: 0;
        }

        & > .MuiAccordion-root,
        & > .MuiAccordion-root.Mui-expanded {
            margin: 0 !important; // Because other !important

            & .MobileFormSectionHeader {
                padding: 0;
            }

            & > .MuiAccordionSummary-root {
                min-height: 24px;

                & > .MuiAccordionSummary-expandIconWrapper > .MuiIconButton-root {
                    padding: 0;
                }
            }
        }
    }

    & .MobileFormSection > .MobileFormSection {
        background-color: transparent;
        padding: 0;
        border-width: 0;
    }

    & .MobileFormBlock {
        display: block;
    }

    & > *,
    & .MobileFormSection,
    & .MobileFormSection > *,
    & .MobileFormBlock,
    & .MobileFormBlock > * {
        margin: ${theme.spacing(2)} 0 0 0;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    & .MuiAccordion-root .MuiAccordionDetails-root > * {
        margin: ${theme.spacing(2)} 0 0 0;
    }

    & .MobileFormSection > *,
    & .MobileFormBlock > *,
    & .MuiAccordionDetails-root > * {
        padding: 0;
    }

    // MUI

    & .MuiFormControl-root {
        display: flex;
    }

    & .MuiTextField-root > label + .MuiInput-root {
        margin-top: 12px;
    }

    & .MuiCheckbox-root,
    & .MuiRadio-root {
        padding: 2px 5px;
        margin-left: -7px; // slight change of position to left align the circle/square with the surrounding content
    }

    & .MuiSelect-select {
        // padding-left to fix alignment of selected value (which would otherwise look misaligned with all other fields)
        // padding-top and bottom to make spacing more consistent with text field
        padding: 4px 16px 4px 0;

        &.MuiSelect-outlined {
            padding: 8px 32px 8px 16px;
        }
    }

    & .MuiOutlinedInput-input {
        padding: 8px 32px 8px 16px;
    }

    // Fix alignment of checkbox and label

    & .MuiFormControlLabel-root {
        display: inline-flex;
        align-items: center;
        margin-left: 0;
    }

    & .MobileFormSection > .DateTimePicker > .MuiFormControl-root {
        margin-bottom: 0;
    }
`;

export const CIS4mStyled = forwardRef((props: Props, ref: any) => {
    const { children, className } = props;

    const theme = useTheme();

    const referencedChildren = useConnectToChildCIS4mComponents(ref, children);

    return <div className={cx('CIS4mStyled', getCIS4mStyledCSS(theme), className)}>{referencedChildren}</div>;
});

CIS4mStyled.displayName = 'CIS4mStyled';
